var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.centered ? 'centered' : ''},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"100","width":"10"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }